// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  gst: 9,
  payCurrency: "USD",
  payCurrencySign: "$",
  eeDownloadUrl: process.env['APP_EE_DOWNLOAD_URL'] ?? "https://demo-tasking.eartheye.space/api/task/",
  eeTaskServer: process.env['APP_EE_TASK_URL'] ?? "https://demo-tasking.eartheye.space/api/task",
  usersServer: process.env['APP_EE_USER_URL'] ?? "https://demo-tasking.eartheye.space/api/user",
  mailServer: process.env['APP_EE_MAIL_URL'] ?? "https://demo-tasking.eartheye.space/api/email",
  demoView: process.env['APP_EE_DEMO_VIEW'] ?? "false",
  openCageApiKey: process.env['APP_EE_OPENCAGE_APIKEY'] ?? '',
  eeAssetsUrl: process.env['APP_EE_ASSETS_URL'] ?? "https://ee-website-assets.s3.amazonaws.com/develop/",
   recaptcha: {
    siteKey: '6Ld1FIwsAAAAAPLqSLOyS6XD5Edwn72wIyTjOwht',
  },
  minAllocationAmt: 150,
  postHogKey: process.env['APP_EE_POSTHOG_KEY'] ?? '',
  chatbotServer: process.env['APP_EE_CHATBOT_URL'] ?? "https://dup4c4xb4b9ht.cloudfront.net",
  isCopernicusLoad: process.env['APP_EE_COPERNICUS_LOAD'] ?? "false",
  geoServerUrl: process.env['APP_EE_GEO_SERVER_URL'] ?? "https://geo-pub-preprod.prodapps.eartheye.space/wms",
  enableSentinelBaseMap: "false",
};
